<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailBroadcastMessage' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
          style="margin: 0.6rem 0"
        ></BrandDropdown>
      </div>
      <div class="col-3">
        <label for="sentDateFrom">Sent date from</label>
        <date-picker
          id="sentDateFrom"
          v-bind="$attrs"
          v-model="sentDateFrom"
          format="D MMMM yyyy"
          lang="en"
          :value="sentDateFrom"
          @change="
            changeStartDate($event);
            sentDateFrom = $event;
          "
        />
      </div>
      <div class="col-3">
        <label for="sentDateTo">Sent date to</label>
        <date-picker
          id="sentDateTo"
          v-bind="$attrs"
          v-model="sentDateTo"
          format="D MMMM yyyy"
          lang="en"
          :value="sentDateTo"
          :minDate="sentDateFrom"
          @change="sentDateTo = $event"
        />
      </div>
      <div class="col-3">
        <label for="keyword">Keyword</label>
        <input
          id="keyword"
          type="text"
          v-model="keyword"
          class="form-control"
          style="margin: 0.7rem 0"
        />
      </div>
    </div>
    <div class="row mt-0">
      <div class="col-3">
        <label for="type">Type</label>
        <multiselect
          id="type"
          v-model="typeSelected"
          :options="types"
          label="text"
          track-by="text"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
      <div class="col-3">
        <label for="broadcastType">Broadcast type</label>
        <multiselect
          id="broadcastType"
          v-model="broadcastTypeSelected"
          :options="broadcastType"
          label="text"
          track-by="text"
          style="margin: 0.6rem 0"
        >
        </multiselect>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-secondary"
          style="width: 100%; max-width: 131px"
          @click="resetFilter"
        >
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="searchBroadcastMessage"
        >
          OK
        </button>
      </div>
    </div>

    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listBroadcastMessages"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailBroadcastMessage',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import moment from "moment";
import BroadcastMessagesService from "services/api/broadcastMessages.service";
import DefaultListViewData from "@/views/defaultListViewData";
import DatePicker from "components/Datepicker/Datepicker.vue";
import fields from "./listBroadcastMessageFields.json";

export default {
  components: {
    DatePicker,
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      sentDateFrom: null,
      sentDateTo: null,
      keyword: null,
      types: [{ text: "LINE" }, { text: "SMS" }, { text: "PUSH_NOTI" }],
      typeSelected: null,
      broadcastType: [{ text: "Trigger" }, { text: "Normal" }],
      broadcastTypeSelected: { text: "Normal" },
      isLoading: false,
      isSubmit: false,
      message: null,
      listBroadcastMessages: [],
      fields,
    };
  },

  mounted() {
    this.isLoading = true;
    this.getBroadcastMessageList(this.sort);
  },

  methods: {
    async getBroadcastMessageList(sort) {
      try {
        const param = this.getParams(sort);

        await BroadcastMessagesService.getListBroadcastMessages(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listBroadcastMessages = data.broadcastMessages.map((b) => {
              return {
                ...b,
                type: this.getType(b.type),
                customerDataType:
                  b.customerDataType === "MOBILE" ? "Mobile" : "Member ID",
                sendTime: moment(b.sendTime).format("YYYY-MM-DD HH:mm"),
              };
            });

            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    getParams(sort) {
      return {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        sendDateFrom: this.sentDateFrom,
        sendDateTo: this.sentDateTo,
        type: this.typeSelected ? this.typeSelected.text : null,
        broadcastType: this.broadcastTypeSelected
          ? this.broadcastTypeSelected.text.toUpperCase()
          : null,
        key: this.keyword,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: sort.key || "id",
        sortType: sort.type || "desc",
      };
    },
    getType(type) {
      if (type === "LINE") {
        return "Line";
      }
      return type === "SMS" ? "SMS" : "Push notification";
    },
    changePage() {
      this.getBroadcastMessageList(this.sort);
    },
    onChangeEntries() {
      this.getBroadcastMessageList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getBroadcastMessageList(this.sort);
    },
    changeStartDate(val) {
      if (val > this.sentDateTo) {
        this.sentDateTo = null;
      }
    },
    searchBroadcastMessage() {
      this.isLoading = true;
      this.getBroadcastMessageList(this.sort);
    },
    resetFilter() {
      this.brandSelected = null;
      this.sentDateFrom = null;
      this.sentDateTo = null;
      this.typeSelected = null;
      this.broadcastTypeSelected = null;
      this.keyword = null;
      this.getBroadcastMessageList(this.sort);
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
